<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-card__brand">
        <div class="login-card__logo"><i class="el-icon-position" /></div>
        <h1>在途智运</h1>
        <p>车辆运输监控开放平台</p>
      </div>
      <el-form ref="form" :model="form" :rules="rules" @keyup.enter.native="submit">
        <el-form-item prop="username">
          <el-input v-model.trim="form.username" prefix-icon="el-icon-user" autocomplete="username" placeholder="请输入账号" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" prefix-icon="el-icon-lock" type="password" show-password autocomplete="current-password" placeholder="请输入密码" />
        </el-form-item>
        <el-button class="login-card__submit" type="primary" :loading="loading" @click="submit">登录</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { hasPermission, login } from '@/utils/auth'
import { firstAuthorizedPath } from '@/utils/permissionNavigation'

export default {
  name: 'InTransitLogin',
  data() {
    return {
      loading: false,
      form: { username: '', password: '' },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid || this.loading) return
        this.loading = true
        let authenticated = false
        try {
          const user = await login(this.form.username, this.form.password)
          authenticated = true
          const redirect = String(this.$route.query.redirect || '')
          // 先选本人有权的落点，避免正常权限重定向被误当作登录失败。
          let target = firstAuthorizedPath(user)
          if (redirect.startsWith('/') && !redirect.startsWith('//')) {
            const destination = this.$router.resolve(redirect).route
            const permission = destination.name === 'LingDongRoutePlannerName'
              ? (destination.query.routeId ? 'route:edit' : 'route:add')
              : destination.meta && destination.meta.permission
            if (destination.matched.length && destination.name !== 'InTransitLogin' &&
                (!permission || hasPermission(permission, user))) target = redirect
          }
          await this.$router.replace(target)
        } catch (error) {
          this.$message.error(error.msg || (authenticated ? '页面跳转失败，请重试' : '登录失败'))
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 24px;
  background: radial-gradient(circle at 76% 18%, rgba(50, 130, 255, .24), transparent 32%), linear-gradient(135deg, #0d1f3c, #173f74 60%, #0b2b53);
}

.login-card {
  width: 410px;
  padding: 42px 44px 46px;
  border-radius: 12px;
  background: rgba(255, 255, 255, .98);
  box-shadow: 0 24px 70px rgba(3, 17, 38, .34);
}

.login-card__brand { margin-bottom: 32px; text-align: center; }
.login-card__logo { display: inline-flex; align-items: center; justify-content: center; width: 58px; height: 58px; color: #fff; font-size: 30px; border-radius: 16px; background: #1677ff; box-shadow: 0 10px 22px rgba(22, 119, 255, .3); }
.login-card h1 { margin: 18px 0 8px; color: #14233c; font-size: 28px; }
.login-card p { margin: 0; color: #8492a6; }
.login-card__submit { width: 100%; margin-top: 8px; }
</style>
